import createPersistedState from 'vuex-persistedstate'
// TODO加密
// import SecureLS from 'secure-ls'
// var ls = new SecureLS({ isCompression: false })
// 导入nuxt.config.js配置后,将自动持久化store文件夹下的state
export default ({ store }) => {
  window.onNuxtReady(() => {
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        // console.log('sessionStorage', val)
        return {
          // 只储存state中的user,不把page放在这里面
          base: val.base,
          browser: val.browser,
        }
      },
    })(store)
    createPersistedState({
      paths: [
        // 'chat.broadcast',
        // 'chat.msgList',
        'chat.visitorUser',
        'chat.contantList',
        'token',
        'refreshToken',
      ],
    })(store)
  })
}

/**
 * http://dev-test.nemikor.com/web-storage/support-test/
 * 许多开发人员认为一个字符等于一个字节,但这不是一个安全的假设。JavaScript中的字符串为UTF-16,因此每个字符需要两个字节的内存。这意味着尽管许多浏览器的限制为5 MB,但您只能存储2.5 M个字符。
 */
if (process.env.NODE_ENV !== 'production' && process.client) {
  if (!window.localStorage) {
    console.log('浏览器不支持localStorage')
  } else {
    let size = 0
    for (const key of Object.keys(window.localStorage)) {
      size += window.localStorage.getItem(key).length
    }
    console.log(`当前localStorage已用存储：${(size / 1024).toFixed(2)}KB`)
  }

  if (!window.sessionStorage) {
    console.log('浏览器不支持sessionStorage')
  } else {
    let size = 0
    for (const key of Object.keys(window.sessionStorage)) {
      size += window.sessionStorage.getItem(key).length
    }
    console.log(`当前sessionStorage已用存储：${(size / 1024).toFixed(2)}KB`)
  }
}
